import React, { ReactNode, useState } from "react";

import {
  Box,
  Card,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

import RemoveIcon from "@mui/icons-material/Remove";

import AddIcon from "@mui/icons-material/Add";

import { cardOutlinedSx } from "../steps/purchase/styles";

type Props = {
  title: string;
  collapsedTitle?: string;
  defaultExpanded?: boolean;
  preview?: ReactNode;
  children: ReactNode;
};

export function CollapsibleSectionCard({
  title,
  collapsedTitle,
  defaultExpanded = true,
  preview,
  children,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const displayTitle = !expanded && collapsedTitle ? collapsedTitle : title;

  return (
    <Card variant="outlined" sx={cardOutlinedSx}>
      <Box
        sx={{
          px: 2.5,
          py: 1.75,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
          <Typography variant="h6" fontWeight={600}>
            {displayTitle}
          </Typography>

          {!expanded && preview ? (
            <Box sx={{ mt: 0.5 }}>
              {typeof preview === "string" ? (
                <Typography variant="body2" color="text.primary" noWrap>
                  {preview}
                </Typography>
              ) : (
                preview
              )}
            </Box>
          ) : null}
        </Stack>

        <IconButton
          aria-label={expanded ? "Recolher" : "Expandir"}
          onClick={() => setExpanded((v) => !v)}
          size="small"
          sx={{ color: "primary.main" }}
        >
          {expanded ? <RemoveIcon /> : <AddIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded} unmountOnExit>
        <Box sx={{ px: 2.5, pb: 2.5, pt: 0.5 }}>{children}</Box>
      </Collapse>
    </Card>
  );
}
